import React, { useRef } from 'react';
import Hero from '../components/Hero';
import Statistics from '../components/Statistics';
import BusinessModel from '../components/BusinessModel';
import WhyInvest from '../components/WhyInvest';
import InvestmentDetails from '../components/InvestmentDetails';
import CityZones from '../components/CityZones';
import JoinMagnificos from '../components/Investments';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

const FranquiciasMagnificos: React.FC = () => {
  const contactFormRef = useRef<HTMLDivElement>(null);

  const scrollToContactForm = () => {
    contactFormRef.current?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  return (
    <div className="franquicias-magnificos bg-white">
      <Hero onSchedule={scrollToContactForm} />
      <Statistics />
      <BusinessModel />
      <WhyInvest />
      <InvestmentDetails onRequestInfo={scrollToContactForm} />
      <JoinMagnificos onSchedule={scrollToContactForm} />
      <CityZones />
      <div ref={contactFormRef}>
        <ContactForm />
      </div>
      <Footer />
    </div>
  );
};

export default FranquiciasMagnificos;